import store from '@/store'
import {brandConfigObjectMap, GameToBrandMap} from '@/brand/brandConfig'
import {translations as enTranslations} from './en'
import {translations as roTranslations} from './ro'

const dictionaries = {
  en: enTranslations,
  ro: roTranslations,
}

function resolveLanguageId() {
  if (store.state.selectedLanguageId) return store.state.selectedLanguageId
  const liveLangFromConfig = (() => {
    const productId = Number(store.state.brandConfig?.productId)
    if (!productId) return null
    const brandKey = GameToBrandMap.get(productId)
    return brandConfigObjectMap.get(brandKey)?.languageId || null
  })()
  return liveLangFromConfig || store.state.brandConfig?.languageId || 'en'
}

export function translate(key, placeholders) {
  const langId = resolveLanguageId()
  const dict = dictionaries[langId] || dictionaries.en
  let str = dict[key]
  if (str == null) str = enTranslations[key]
  if (str == null) return key
  if (Array.isArray(placeholders)) {
    placeholders.forEach((val, i) => {
      str = str.split(`{${i}}`).join(String(val))
    })
  }
  return str
}

export default {
  install(app) {
    app.config.globalProperties.$t = translate
  },
}
